// extracted by mini-css-extract-plugin
var _1 = "styles-module__addPhotosBtn___LcFw3";
var _2 = "styles-module__container___IBJCE";
var _3 = "styles-module__photo____m7QY";
var _4 = "styles-module__photoButton___mpQlh";
var _5 = "styles-module__photoItem___JxkTK";
var _6 = "styles-module__placeholder___Q2PHG";
var _7 = "styles-module__spacer___SSZUR";
var _8 = "styles-module__withPhotos___p5l8y";
export { _1 as "addPhotosBtn", _2 as "container", _3 as "photo", _4 as "photoButton", _5 as "photoItem", _6 as "placeholder", _7 as "spacer", _8 as "withPhotos" }
